const food = [
    {
        id:1,
        name: 'pequeno almoço OM grill',
        price: '6,000'
    },
    {
        id:2,
        name: 'Bife à portuguesa',
        price: '12,000'
    },
    {
        id:3,
        name: 'Grelhada mista',
        price: '35,000'
    }
];

export default food;